<header>
  <div class="ds-mbl-only">
    <button
      myqq-button
      class="fab"
      color="primary"
      aria-label="Go back"
      (click)="cancel()"
      (keydown.enter)="$event.preventDefault()"
      (keyup.enter)="cancel()"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
  </div>
</header>

<div class="background vh-dsk-p100">
  <main>
    <h3>Where Do You Wash Your Car?</h3>

    <form
      [formGroup]="locationForm"
      (keyup.enter)="confirm(locationForm.value)"
      (submit)="confirm(locationForm.value)"
    >
      <mat-form-field id="first_name">
        <mat-label>State</mat-label>
        <select
          matNativeControl
          formControlName="state"
          placeholder="Select State"
          (change)="changeState($event.target.value)"
        >
          <option value=""></option>
          <option
            *ngFor="let state of relevantStates"
            [value]="state.abbreviation"
          >
            {{ state.abbreviation }} - {{ state.name }}
          </option>
        </select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Region</mat-label>
        <select
          matNativeControl
          formControlName="region"
          placeholder="Select Metropolitan Area"
        >
          <option value=""></option>
          <option
            *ngFor="let region of filterRegions"
            [value]="region.regionId"
          >
            {{ region.name }}
          </option>
        </select>
      </mat-form-field>
    </form>

    <footer class="fld-row flg-5 jc-ctr vw-p100">
      <div class="ds-dsk-only">
        <button
          myqq-button
          aria-label="Go back"
          class="raised normal"
          (click)="cancel()"
          fill="clear"
          type="button"
          (keydown.enter)="$event.preventDefault()"
          (keyup.enter)="cancel()"
        >
          Back
        </button>
      </div>

      <button
        myqq-button
        aria-label="Next"
        class="next-btn raised"
        color="primary"
        (keydown.enter)="$event.preventDefault()"
        (click)="confirm(locationForm.value)"
        (keyup.enter)="confirm(locationForm.value)"
        [disabled]="locationForm.invalid"
      >
        Next
      </button>
    </footer>
  </main>
</div>
